import styled from 'styled-components';

import {trackEvent} from '~/shared/services/analytics';
import {secureOpenWindow} from '~/shared/utils/general';
import WhiteLogo from '~/assets/images/white-logo.svg?react';
import {getLocalizationService} from '~/shared/services/localisationService';
import {body12Bold} from '~/shared/theme/typography';
import {media} from '~/shared/theme/media';
import {flipOnLTR} from '~/shared/theme/utils';

import Button from '../Button';

import MomentsLogo from './momentsLogo.svg?react';

const MomentsButton = styled(Button)`
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  padding: 7px 10px;
  width: 193px;
  height: 36px;
  border-radius: 52px;
  background-color: ${({theme}) => theme.colors.gray920};
  ${media.minLargeDesktop`
    ${flipOnLTR`
      margin-left: -8px;
    `}
  `}
`;

const StyledWhiteLogoUrl = styled(WhiteLogo)`
  width: 68px;
  height: 18px;

  g {
    fill: ${({theme}) => theme.colors.contentBrand};
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledMomentsLogo = styled(MomentsLogo).attrs({
  className: 'avoid-fill-stroke',
})`
  top: 2px;
`;

const NewTag = styled.div`
  width: 36px;
  height: 20px;
  padding: 2px 4px;
  background-color: ${({theme}) => theme.colors.contentBrand};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({theme}) => theme.colors.primaryText};
  ${body12Bold}
`;

const MOMENTS_URL = 'https://10bis-moments.co.il/';

const Moments = () => {
  const {t} = getLocalizationService();
  
  const onClick = () => {
    trackEvent('moments_click');
    secureOpenWindow(MOMENTS_URL, '_blank');
  };

  return (
    <MomentsButton onClick={onClick}>
      <Wrapper>
        <StyledWhiteLogoUrl />
        <StyledMomentsLogo />
      </Wrapper>
      <NewTag>{t('New')}</NewTag>
    </MomentsButton>
  );
};

export default Moments;
